module.exports = __webpack_public_path__ + "img/img_change_text01.ea71f8a0.png";